module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0076.jpg?v=ec028baa";